import {Scenario} from "../model";
import {bankReconciliation, interimGap, interimRollforward, journalExceptions} from "./manualControls";
import {automatedControl, automatedControlFailed, benchmarking, benchmarkingChanged, migration} from "./automated";
import {outsourcedPayroll} from "./outsourced";
import {planningAutomated, planningWithFailedItgc} from "./planning";
import {sharedSample} from "./sharedSample";
import {fieldworkUnderway} from "./fieldworkUnderway";

/** In design-document order, so a walkthrough can step straight down the list. */
export const SCENARIOS: Scenario[] = [
  bankReconciliation,
  automatedControl,
  automatedControlFailed,
  interimRollforward,
  interimGap,
  outsourcedPayroll,
  benchmarking,
  benchmarkingChanged,
  journalExceptions,
  migration,
  planningAutomated,
  planningWithFailedItgc,
  sharedSample,
  fieldworkUnderway,
];

/**
 * The scenarios a demo walks, in the order it walks them. The full list stays available underneath;
 * this is what the picker steps through so a scripted run is one click per move rather than a hunt.
 */
export const DEMO_SEQUENCE = ["s8", "s10", "s3", "s6", "s2", "s2-failed", "s5", "s4"];
